import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface ContextMenuProps extends KendoWidgetProps, kendo.ui.ContextMenuOptions {
    children?: React.ReactNode;
}

export default class ContextMenu extends KendoBaseComponent<ContextMenuProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.ContextMenu(domNode as Element, (props as kendo.ui.ContextMenuOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;
            const widget = (this.widgetInstance as kendo.ui.ContextMenu);

            if (props.dataSource && props.dataSource === widget.options.dataSource) {
                delete props.dataSource;
            }

            this.widgetInstance.setOptions(props);
        }

        return (
            <ul ref={this.elementRef}>
                {this.props.children}
            </ul>
        );
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-react-wrapper/src/menu/contextmenu.tsx